// Shared constants for debt type codes and labels (legacy-aligned)
export const DEBT_TYPE_CODES = {
  CREDIT_CARD: { code: 'ZC', label: 'Credit card' },
  STORE_CARD: { code: 'ZS', label: 'Store card' },
  CHARGE_CARD: { code: 'ZG', label: 'Charge card' },
  OVERDRAFT: { code: 'OD', label: 'Overdraft' },
} as const;

// Selectable debt types for the UW "Cards" debt section.
// These codes must exist in the backend account-type master so the debt is
// re-categorised under "Cards" on reload (see DEFAULT_CATEGORY_BY_CODE).
export const CARD_DEBT_TYPES: ReadonlyArray<{ code: string; label: string }> = [
  DEBT_TYPE_CODES.CREDIT_CARD,
  DEBT_TYPE_CODES.STORE_CARD,
  DEBT_TYPE_CODES.CHARGE_CARD,
];

// Selectable debt types for the UW "Loans" debt section.
// `BN` (BNPL) and `EL` (Employer Loan) already exist in the backend
// account-type master; the remaining codes are seeded by
// debt-reference-data.seed.ts. All codes must map to the "loans" category in
// DEFAULT_CATEGORY_BY_CODE so the debt is re-categorised under "Loans" on reload.
export const LOAN_DEBT_TYPES: ReadonlyArray<{ code: string; label: string }> = [
  { code: 'BN', label: 'Buy Now Pay Later' },
  { code: 'PERS', label: 'Personal' },
  { code: 'EL', label: 'Employer loan' },
  { code: 'SECL', label: 'Secured Loan' },
  { code: 'MORT', label: 'Mortgage' },
  { code: 'MOTF', label: 'Motor Finance' },
  { code: 'PSTL', label: 'Private Student Loan' },
];

// Fixed debt type for the UW "Others" debt section. Every entry there is recorded
// under this code; it must exist in the backend account-type master (code 'ZO',
// "Other non priority debts") so the debt is re-categorised under "Others" on reload.
export const OTHER_NON_PRIORITY_DEBT = { code: 'ZO', label: 'Other Non Priority Debt' } as const;

export type LockedCategoryKey = 'creditCards' | 'overdrafts';

export const CATEGORY_LOCKS: Record<LockedCategoryKey, { code: string; label: string }> = {
  creditCards: DEBT_TYPE_CODES.CREDIT_CARD,
  overdrafts: DEBT_TYPE_CODES.OVERDRAFT,
};



